import { ApiService } from '../ApiService';

export class InterviewMarkerService {
  public static destroy(id: number): Promise<void> {
    return ApiService.delete<void>(`/interview_markers/${id}`);
  }
}
